import Modal from '@/components/ui/modals';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/buttons';
import { Spinner } from '@/components/ui/forms';
import ProductCard from '../product-card';

function ReturnModal({ product, isOpen, onClose, isLoading, onReturn, mage }) {
  const t = useTranslations('user');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('return_order_key')}
      maxWidth='max-w-lg'
    >
      <div className='px-4 py-8'>
        <p className='text-center font-semibold'>{t('return_order_msg_key')}</p>

        <div className='my-4'>
          <ProductCard product={product} mage={mage} />
        </div>
        <div className='mt-6 flex justify-center gap-4'>
          <Button className='w-48' onClick={onReturn} disabled={isLoading}>
            {t('return_key')}
            {isLoading && <Spinner />}
          </Button>
          <Button
            onClick={onClose}
            disabled={isLoading}
            className='text-primary! border-border border-2 bg-transparent px-18'
          >
            {t('cancel_key')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default ReturnModal;
